import { Box } from "@mui/material";
import CustomButton from "../UIElements/CustomButton";

export type FooterProps = {
    onClick?: Function;
    label?: string;
    disabledBtn?: boolean;
    readOnly?: boolean;
};

export default function Footer({ onClick, label, disabledBtn, readOnly }: FooterProps) {
    return (
        <Box
            sx={{
                display: "flex",
                padding: "1.5rem 6rem 1.5rem 1.5rem",

                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                gap: "0.625rem",
                background: "#FFF",

                /* Ombre card */
                boxShadow: "0px 4px 30px 0px #E3E6E8",
                "@media (max-width:1024px)": {
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "1.5rem",
                    zIndex: 100,
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-start",
                    gap: "1rem",
                }}
            >
                <CustomButton
                    type="submit"
                    label={label ? label : ""}
                    disabled={disabledBtn}
                    onClick={() => {
                        if (onClick) {
                            onClick();
                        }
                    }}
                />
            </Box>
        </Box>
    );
}
